import { TableColumns } from '@ohpen/enso-ui';
import { FieldType, ChangeRequestResponse } from '@pmp/api';

export const columns: TableColumns<ChangeRequestResponse> = [
  {
    title: 'global.labels.id',
    dataIndex: 'actionId',
    key: 'actionId',
    options: {
      filter: 'search',
      sorter: true,
    },
    width: 290,
  },
  {
    title: 'global.labels.createdAt',
    dataIndex: 'creationTime',
    key: 'creationTime',
    options: {
      format: {
        type: 'dateTimeLocal',
      },
      filter: 'search',
      sorter: true,
    },
    width: 130,
  },
  {
    title: 'global.labels.createdBy',
    dataIndex: 'createdBy',
    key: 'createdBy',
    options: {
      filter: 'search',
      sorter: true,
    },
    width: 260,
  },
  {
    title: 'global.labels.entityType',
    dataIndex: 'actionEntityType',
    key: 'actionEntityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_ENTITY_TYPE,
    },
    width: 180,
  },
  {
    title: 'global.labels.type',
    dataIndex: 'actionType',
    key: 'actionType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ACTION_TYPE,
    },
    width: 80,
  },
  {
    title: 'global.labels.status',
    dataIndex: 'status',
    key: 'status',
    options: {
      format: {
        type: 'tag',
      },
      filter: 'select',
      listName: FieldType.ACTION_STATUS,
      sorter: true,
    },
    width: 140,
  },
  {
    title: 'global.labels.reviewedAt',
    dataIndex: 'timeOfReview',
    key: 'timeOfReview',
    options: {
      format: {
        type: 'dateTimeLocal',
      },
      filter: 'search',
      sorter: true,
    },
    width: 130,
  },
  {
    title: 'global.labels.reviewedBy',
    dataIndex: 'reviewedBy',
    key: 'reviewedBy',
    options: {
      filter: 'search',
      sorter: true,
    },
    width: 260,
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 230, fixed: 'right' },
];
